import firebaseMessagingService from "../services/firebaseMessaging";
import secureStorage from "./secureStorage";

/**
 * Get the current FCM token
 * Returns the stored token or fetches a new one if needed
 */
export const getCurrentFCMToken = async () => {
  try {
    // First try to get from secureStorage
    const storedToken = secureStorage.getItem("fcmToken");
    if (storedToken) {
      return storedToken;
    }

    // If no stored token, try to get from Firebase service
    const token = await firebaseMessagingService.getToken();
    if (token) {
      return token;
    }

    // No token available - return null instead of hardcoded fallback
    return null;
  } catch (error) {
    // Return null on error - let the calling code handle missing tokens
    return null;
  }
};

/**
 * Set FCM token in secureStorage
 */
export const setFCMToken = (token) => {
  if (token) {
    secureStorage.setItem("fcmToken", token);
  }
};

/**
 * Clear FCM token from secureStorage
 */
export const clearFCMToken = () => {
  secureStorage.removeItem("fcmToken");
};

/**
 * Check if FCM token exists
 */
export const hasFCMToken = () => {
  return !!secureStorage.getItem("fcmToken");
};
